module.exports = __webpack_public_path__ + "static/mobile-circles-16c0e739df7e3ab218b56ecf3a1b3790.svg";